export default (wait, onFinish) => {
  let timeout;
  return (...args) => {
    const later = () => {
      timeout = null;
      onFinish(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};
